import { ResourceTypes } from '@api/v4/resources/resourceTypes';
import { ErrorInterface } from '@api/v4/apiHelperTypes';
import { PublishResponseJSON } from '@api/v4/private/smartsheet/publish';

export type SelectedResources = Partial<{ [key in ResourceTypes]: string | null }>
export type SelectedLabels = { [labelKey: string]: boolean }

export interface PostMessageDataReceived {
  proof: { externalUrl: string; id: number; name: string };
  row: { id: number; url: string };
  sheet: { id: number; url: string };
  attachments?: Attachment[];
  customFields?: CustomField[];
  tags?: Tag[];
}

export interface Status {
  context: PayloadContext;
  status: Statuses;
  body?: PayloadBody | PublishResponseJSON;
}

export type Statuses = 200 | 202 | 400 | 401 | 403 | 404 | 500

type Attachment = { filename: string; size: number; url: string }
type CustomField = { name: string; value: string }
type Tag = { name: string }

type PayloadBody = {
  assetUrl?: string;
  error?: ErrorInterface | unknown;
  event?: MessageEvent;
  message?: Messages;
  openerOrigin?: string;
}

export enum Messages {
  FetchResourcesError = bfTranslate('Error fetching resources'),
  FetchResourcesSuccess = bfTranslate('Resources successfully fetched'),
  OriginMismatch = bfTranslate('Event origin does not match opener origin'),
  PostMessageError = bfTranslate('Error executing postMessage'),
  PublishAssetError = bfTranslate('Error publishing asset to Brandfolder'),
  PublishAssetSuccess = bfTranslate('Asset successfully created in Brandfolder!'),
  Ready = bfTranslate('Ready!'),
}

export enum PayloadContext {
  FetchResources = 'fetch-resources',
  PostMessage = 'post-message',
  PublishAsset = 'publish-asset',
  Setup = 'setup',
}

export enum Views {
  Form = 'form',
  Loading = 'loading',
  NoResources = 'noResources',
  SubmitSuccess = 'submitSuccess'
}
